
import { createClient } from "@supabase/supabase-js"
// const supabaseKey = process.env.SUPABASE_KEY

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl,supabaseAnonKey)
